module.exports = __webpack_public_path__ + "img/item-reviews.003893c7.svg";